import { selectFeatureFlag } from '../../selectors/feature-flags';

/**
 *
 * @returns {number}
 */
export const getTrailersByCustomerSize = state => selectFeatureFlag(state, 'trailers-by-customer-size');
